import { actions } from '@app/store/action/billingdetails';

export default function (state = {}, action) {
  const { type } = action;

  switch (type) {
    case actions.GET_BILLING_DETAILS:
    case actions.UPDATE_BILLING_DETAILS_SUCCESS:
      return {
        ...state,
        ...action.details,
      };
  }

  return state;
}
